import { defineStore } from "pinia";

import { type IPlanPriceRepository } from "~/interfaces/IPlanPriceRepository";
import { PlanPriceRepository } from "~/repositories/PlanPriceRepository";
import { type IPlanPriceHistory, type IPlanPriceListResponse } from "~/entities/PlanPriceHistory";

export const usePlanPriceStore = defineStore("PlanPriceStore", () => {
  // repositories
  const planPriceRepo: IPlanPriceRepository = new PlanPriceRepository();

  // states
  const loading = ref(false);
  const loadingChangeHistory = ref(false);

  const planPrices = ref<IPlanPriceListResponse>();
  const changeHistories = ref<IPlanPriceListResponse>();

  // actions
  const fetch = async (planId: string, page: number, pageSize: number) => {
    loading.value = true;
    try {
      const res = await planPriceRepo.fetch(planId, page, pageSize);
      planPrices.value = res;
    } finally {
      loading.value = false;
    }
  };

  const create = async (planId: string, planPrice: IPlanPriceHistory) => {
    await planPriceRepo.create(planId, planPrice);
  };

  const update = async (planPrice: IPlanPriceHistory) => {
    await planPriceRepo.update(planPrice);
  };

  const deletePrice = async (planPriceId: string) => {
    await planPriceRepo.deletePrice(planPriceId);
  };

  const fetchChangeHistory = async (planPriceId: string, page: number, pageSize: number) => {
    loadingChangeHistory.value = true;
    try {
      const res = await planPriceRepo.fetchChangeHistory(planPriceId, page, pageSize);
      changeHistories.value = res;
    } finally {
      loadingChangeHistory.value = false;
    }
  };

  const setDisplayOrders = async (planPrices: IPlanPriceHistory[]) => {
    await planPriceRepo.setDisplayOrders(planPrices);
  };

  return {
    loading,
    loadingChangeHistory,
    planPrices,
    changeHistories,
    fetch,
    create,
    update,
    deletePrice,
    fetchChangeHistory,
    setDisplayOrders,
  };
});
